<template>
  <div id="trade-layout">
    <div class="container">
      <div class="lg:tw-px-4 tw-mb-12">
        <div class="sm:tw-flex">
          <BackBtn class="tw-hidden sm:tw-block tw-mr-6" />
          <div>
            <h3 class="tw-text-2xl tw-font-bold tw-pb-1">Trade</h3>
            <p class="tw-text-black-light tw-mb-6">
              Invest in promising startups on this list
            </p>
          </div>
        </div>
        <ListingCard />
        <div class="tw-bg-white tw-rounded-lg tw-px-4 tw-pt-6 tw-mt-16">
          <TableHead
            :options="options"
            :tab="option"
            label="options"
            @emitOption="emitOption"
          />
          <RaisingTable v-if="option === 'Listings'" />
          <RaisedCard v-if="option === 'Secondaries'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ListingCard from "@/components/trade/ListingCard.vue";
import TableHead from "@/components/tables/TableHeader";
import RaisingTable from "@/components/tables/invest/RaisingTable.vue";
import RaisedCard from "@/components/invest/RaisedCard.vue";
import BackBtn from "@/components/general/BackBtn";

export default {
  name: "Trade",

  components: { ListingCard, RaisingTable, TableHead, BackBtn, RaisedCard },

  data() {
    return {
      options: ["Listings", "Secondaries"],
      option: "",
    };
  },

  computed: {
    ...mapState({
      smallLoading: (state) => state.smallLoading,
    }),
  },

  methods: {
    emitOption(option) {
      switch (option) {
        case "Listings":
          this.option = "Listings";
          break;
        case "Secondaries":
          this.option = "Secondaries";
          break;

        default:
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#trade-layout {
  width: 100%;
  overflow: hidden;

  .container {
    @include fadeIn;

    @media screen and (min-width: 1024px) {
      max-width: 1280px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  .table-container {
    overflow: auto;
  }

  .message {
    max-width: 250px;
  }
}
</style>